export { ReactTableWrapper as default } from 'Common/Components';



// WEBPACK FOOTER //
// ./src/common/ReactTableWrapper.js